<template>
  <div class="order-container">
    <VPayment :workbench="true"   :checkout="true"/>
  </div>
</template>

<script setup>
  import VPayment from '../../register/payment/index.vue'
  import { ref, inject, onMounted, provide } from 'vue'
  import { getSteps } from '@/api/config'

  const $event = inject('$event')
  const steps = ref([])

  onMounted(async () => {
    const { data } = await getSteps()
    steps.value = data
  })

  provide('$steps', steps)
</script>

<style lang="scss" scoped>
  .order-container {
    margin: 0;
    overflow-y: auto;
    max-height: 100%;
    padding: 20px;
    :deep() {
      .register-container {
        background: #ffffff;
        box-shadow: 0px 0px 16px rgba(54, 63, 94, 0.08);
        border-radius: 8px;
        border-width: 0;
        margin: 0;
        max-width: 960px;
        margin: 0 auto;
        .wrapper {
          margin-top: 0;
        }
      }
    }
  }
</style>
